import { useState, useRef, useCallback, useEffect } from "react";
import GameMap from './assests/svg/game-map.svg';
import DeskMap from './assests/svg/desk.svg';
import { useNavigate } from "react-router-dom";

import './GameSVG.css';
import success from "./images/success.gif";
import Swal from "sweetalert2";
import { updateReport, fetchReport } from "../../scoreservice";

const GameSVG = ({ time }) => {
  const [svgLoaded, setSvgLoaded] = useState(false);
  const svgRef = useRef(null);
  const draggedItem = useRef(null);
  const positions = useRef({});

  const navigate = useNavigate();
  // const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const [userData, setUserData] = useState({});

  useEffect(() => {
    const storedUserData = sessionStorage.getItem("userData");
    if (storedUserData) {
      setUserData(JSON.parse(storedUserData));
    }
  }, []);


  const STAGE = 1;

  const latestTimeRef = useRef(time);
  const submittedRef = useRef(false);

  // Function to detect if device is mobile
  const isMobile = () => {
    return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  };

  const isLandscape = () => {
    return window.innerWidth > window.innerHeight;
  };


  // Get appropriate SVG based on device
  // const getSvgFile = () => {
  //   return isMobile() ? GameMap : DeskMap;
  // };

  const getSvgFile = () => {
    // Mobile portrait → GameMap
    if (isMobile() && !isLandscape()) {
      return GameMap;
    }

    // Mobile landscape OR Desktop → DeskMap
    return DeskMap;
  };



  useEffect(() => {
    console.log("check stage completion! svg");
    const checkStageCompletion = async () => {
      try {
        const res = await fetchReport({
          sessionId: userData.sessionId,
          userId: userData.userId,
          organizationId: userData.organizationId,
          reportId: userData.reportId
        });

        // ✅ adjust key name if your API differs
        if (res?.stage1_score && res.stage1_score !== "") {
          navigate("/stage2", { replace: true });
        }

      } catch (err) {
        console.error("Stage check failed", err);
      }
    };

    checkStageCompletion();
  }, []);

  const checkAllSimsCompleted = useCallback(() => {

    console.log("submit when sims completed");
    const userData1 = JSON.parse(sessionStorage.getItem("userData") || "{}");
    console.log(userData1, "feching userdata");

    // Get all sim elements
    const sims = Array.from(document.querySelectorAll('[id^="sim"]')).filter(el =>
      el.id.match(/^sim\d+$/) // Only match sim1, sim2, etc.
    );
    console.log(sims);
    // Check if all sim elements are visible
    const allCompleted = sims.every(sim =>
      window.getComputedStyle(sim).display !== 'none'
    );
    console.log("allCompleted", allCompleted);
    if (allCompleted) {
      console.log("All sims completed!");
      // alert('Congratulations! All pieces are in place!');
      const SESSION_KEY = `stage_timer_${userData1.sessionId}_${userData1.userId}`;
      const sessionData = sessionStorage.getItem(SESSION_KEY);
      const { startTime } = JSON.parse(sessionData);
      const elapsedMs = Date.now() - startTime;
      const totalSeconds = Math.floor(elapsedMs / 1000);

      const mins = Math.floor(totalSeconds / 60);
      const secs = totalSeconds % 60;

      const formattedTime = `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
      updateReport({
        sessionId: userData1.sessionId,
        userId: userData1.userId,
        organizationId: userData1.organizationId,
        reportId: userData1.reportId,
        stage: STAGE,
        score: 1,
        time:formattedTime,
        roles:userData1.roles,
        token:userData1.token || ""
      });
      
      Swal.fire({
        imageUrl: success,
        showConfirmButton: false,
        background: "transparent",
        timer: 3000
      }).then(() => navigate("/stage2"));
    }
    return allCompleted;
  }, []);

  const handleStart = useCallback((e) => {
    if (!e.target.classList.contains('draggable')) return;
    e.preventDefault();

    const target = e.target;
    target.style.cursor = 'grabbing';
    target.style.pointerEvents = 'none';

    // Get current transform
    const transform = target.getAttribute('transform');
    console.log("Initial transform:", transform);
    let currentX = 0;
    let currentY = 0;
    let scale = 1; // Default scale

    if (transform) {
      // Check for matrix format: matrix(a b c d e f)
      const matrixMatch = transform.match(/matrix\(([^)]+)\)/);
      if (matrixMatch && matrixMatch[1]) {
        const matrix = matrixMatch[1].split(/\s+/).map(Number);
        currentX = matrix[4];
        currentY = matrix[5];
        scale = matrix[0]; // Scale is in position 0 (and 1 for uniform scale)
        console.log("Using matrix format:", currentX, currentY, "scale:", scale);
      }
      // Check for translate format: translate(x y) scale(s)
      else {
        const translateMatch = transform.match(/translate\(([^)]+)\)/);
        if (translateMatch && translateMatch[1]) {
          const coords = translateMatch[1].split(/\s+/);
          currentX = parseFloat(coords[0]) || 0;
          currentY = parseFloat(coords[1]) || 0;
          console.log("Using translate format:", currentX, currentY);

          // Check for scale in the same transform
          const scaleMatch = transform.match(/scale\(([^)]+)\)/);
          if (scaleMatch && scaleMatch[1]) {
            scale = parseFloat(scaleMatch[1]) || 1;
            console.log("Found scale:", scale);
          }
        }
      }
    }

    // If still no position (transform is null/empty), get actual position from element
    if (currentX === 0 && currentY === 0) {
      const bbox = target.getBBox();
      currentX = bbox.x;
      currentY = bbox.y;
      console.log("Using BBox position:", currentX, currentY);
    }

    console.log("Final position:", currentX, currentY, "scale:", scale);

    // Get coordinates from touch or mouse event
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    // Calculate offset
    const rect = target.getBoundingClientRect();
    const offsetX = clientX - rect.left;
    const offsetY = clientY - rect.top;

    draggedItem.current = {
      element: target,
      startX: currentX,
      startY: currentY,
      originalX: currentX,
      originalY: currentY,
      scale: scale,
      offsetX,
      offsetY
    };

    console.log("Parsed position:", draggedItem.current);

    // Add appropriate event listeners
    if (e.touches) {
      // Touch events
      document.addEventListener('touchmove', handleMove, { passive: false });
      document.addEventListener('touchend', handleEnd, { once: true });
    } else {
      // Mouse events
      document.addEventListener('mousemove', handleMove);
      document.addEventListener('mouseup', handleEnd, { once: true });
    }
  }, []);

  const handleMove = useCallback((e) => {
    if (!draggedItem.current) return;
    const { element, offsetX, offsetY, scale } = draggedItem.current;
    const svg = element.ownerSVGElement;

    // Get coordinates from touch or mouse event
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    // Convert position to SVG coordinates
    const point = svg.createSVGPoint();
    point.x = clientX;

    point.y = clientY;
    const svgPoint = point.matrixTransform(svg.getScreenCTM().inverse());

    // Calculate new position
    const newX = svgPoint.x - offsetX;
    const newY = svgPoint.y - offsetY;

    // Update element's transform with preserved scale
    element.setAttribute('transform', `matrix(${scale} 0 0 ${scale} ${newX} ${newY})`);
  }, []);

  const handleEnd = useCallback((e) => {
    if (!draggedItem.current) return;
    const target = draggedItem.current.element;
    const svg = target.ownerSVGElement;
    const simBorder = document.getElementById('Sim_Border');
    let shouldRevert = true;

    // Get coordinates from touch or mouse event
    const clientX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
    const clientY = e.changedTouches ? e.changedTouches[0].clientY : e.clientY;

    // Convert position to SVG coordinates
    const point = svg.createSVGPoint();
    point.x = clientX;
    point.y = clientY;
    const svgPoint = point.matrixTransform(svg.getScreenCTM().inverse());

    // Check if we're over Sim_Border
    if (simBorder) {
      const borderBox = simBorder.getBBox
        ? simBorder.getBBox()
        : simBorder.getBoundingClientRect();

      if (svgPoint.x >= borderBox.x &&
        svgPoint.x <= borderBox.x + borderBox.width &&
        svgPoint.y >= borderBox.y &&
        svgPoint.y <= borderBox.y + borderBox.height) {

        console.log("Dropped on Sim_Border");
        const simId = `sim${target.id.replace('peice', '')}`;
        const simElement = document.getElementById(simId);
        if (simElement) {
          // Hide dragged piece
          target.style.display = 'none';
          // Show corresponding sim element
          simElement.style.display = 'block';

          // Store position
          positions.current[target.id] = {
            x: svgPoint.x,
            y: svgPoint.y,
            isDropped: true
          };

          shouldRevert = false;

          // Check if all sims are completed
          checkAllSimsCompleted();
        }
      }
    }

    // Revert if needed
    if (shouldRevert) {
      console.log("Reverting position", draggedItem.current);
      const { originalX, originalY, scale } = draggedItem.current;
      //console.log("Original position:", draggedItem.originalX, draggedItem.originalY);
      target.style.transition = 'transform 0.3s ease';
      target.setAttribute('transform', `matrix(${scale} 0 0 ${scale} ${originalX} ${originalY})`);
      target.style.display = '';

      setTimeout(() => {
        target.style.transition = 'none';
      }, 300);
    }

    // Clean up
    target.style.cursor = 'grab';
    target.style.pointerEvents = 'auto';
    draggedItem.current = null;

    // Remove both mouse and touch event listeners
    document.removeEventListener('mousemove', handleMove);
    document.removeEventListener('touchmove', handleMove);
    document.removeEventListener('mouseup', handleEnd);
    document.removeEventListener('touchend', handleEnd);
  }, [handleMove, checkAllSimsCompleted]);

  // Load and process SVG
  useEffect(() => {
    if (!svgRef.current) return;

    const loadAndProcessSvg = async () => {
      try {
        const svgFile = getSvgFile();
        console.log('Loading SVG:', isMobile() ? 'game-map.svg (mobile)' : 'desk.svg (desktop)');
        const response = await fetch(svgFile);
        const svgText = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(svgText, 'image/svg+xml');
        const svg = doc.querySelector('svg');

        if (!svg) return;

        // Set up SVG
        svg.classList.add('game-svg');
        if (!svg.getAttribute('viewBox')) {
          svg.setAttribute('viewBox', '0 0 800 600');
        }

        // Make elements with IDs draggable
        const elements = svg.querySelectorAll('[id]');
        elements.forEach(el => {
          if (el.id.includes('peice')) {
            el.classList.add('draggable');
            el.style.cursor = 'grab';
            el.style.transition = 'none';

            // Apply saved positions
            if (positions.current[el.id]) {
              const { x, y } = positions.current[el.id];
              el.style.transform = `translate(${x}px, ${y}px)`;
            }
          }
        });

        // Create container and append SVG
        const container = document.createElement('div');
        container.className = 'svg-content';
        container.appendChild(svg);
        svgRef.current.innerHTML = '';
        svgRef.current.appendChild(container);

        // Mark SVG as loaded
        setSvgLoaded(true);

        // Add event listeners for both mouse and touch
        const handleContainerStart = (e) => {
          if (e.target.classList.contains('draggable')) {
            e.stopPropagation();
            handleStart(e);
          }
        };

        container.addEventListener('mousedown', handleContainerStart);
        container.addEventListener('touchstart', handleContainerStart, { passive: false });

        return () => {
          container.removeEventListener('mousedown', handleContainerStart);
          container.removeEventListener('touchstart', handleContainerStart);
          document.removeEventListener('mousemove', handleMove);
          document.removeEventListener('touchmove', handleMove);
          document.removeEventListener('mouseup', handleEnd);
          document.removeEventListener('touchend', handleEnd);
          setSvgLoaded(false);
        };
      } catch (error) {
        console.error('Error loading SVG:', error);
      }
    };

    loadAndProcessSvg();
  }, [handleStart, handleMove, handleEnd, isMobile()]);

 return (
  <div className="game-container">
    {/* Title above SVG */}
    <div className="svg-title">
      Rebuild the SIM card by placing each piece in the right spot.
    </div>

    <div className="svg-container" ref={svgRef}></div>
  </div>
);

};

export default GameSVG;